// src/config/env.js

/*   const config = {
  //apiUrl: process.env.REACT_APP_API_URL || 'http://machakos.test.com:5000'
  //apiUrl: process.env.REACT_APP_API_URL || 'http://nakuru.test.com:5000'
  apiUrl: process.env.REACT_APP_API_URL || 'http://crown.test.com:5000'
  //apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000'
}; */

// export default config;

const config = {
  apiUrl: process.env.REACT_APP_API_URL || "",
};

export default config;
